import { render, staticRenderFns } from "./VettingListItem.vue?vue&type=template&id=25d6c878"
import script from "./VettingListItem.vue?vue&type=script&lang=js"
export * from "./VettingListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports